module.exports = __webpack_public_path__ + "img/manual.b7de37f8.svg";